<template>
  <div class="mt-3 pb-4 mb-4 font-jumper">
    <b-modal ref="saveWarning" hide-footer>
      {{ warningMessage }}

      <div style="text-align: right" class="mt-4">
        <b-button
          class="mx-2"
          variant="danger"
          @click="$refs.saveWarning.hide()"
          >Mégsem
        </b-button>
        <b-button
          class="mx-2"
          variant="success"
          @click="
            () => {
              $refs.saveWarning.hide();
              save(true);
            }
          "
          >Mentés mindenképp
        </b-button>
      </div>
    </b-modal>

    <b-container fluid id="new-employee-container" class="employee-torzsadat pt-4 col-12">
      <b-row>
        <b-col
          class="ml-0 profile-input-container"
          cols="12"
          style="min-height: 300px"
        >
          <div class="employee-layout">
            <section class="employee-section-card" aria-label="Törzsadat">
              <header class="employee-section-header">
                <h2 id="torzsadat-heading" class="employee-section-title d-none d-md-block">Törzsadat</h2>
                <button
                  type="button"
                  class="employee-section-toggle d-md-none"
                  aria-controls="torzsadat-panel"
                  :aria-expanded="String(torzsadatOpen)"
                  @click="torzsadatOpen = !torzsadatOpen"
                >
                  <span>Törzsadat</span>
                  <b-icon :icon="torzsadatOpen ? 'chevron-up' : 'chevron-down'" aria-hidden="true"></b-icon>
                </button>
              </header>

              <b-collapse id="torzsadat-panel" v-model="torzsadatOpen" class="employee-section-body">
                <div class="employee-fields-grid">
                  <div class="data-wrapper employee-field-full">
                    <label class="employee-field-label employee-field-title" for="employee-employment-mode">
                      Foglalkoztatás módja
                    </label>
                    <Dropdown
                      
                      id="employee-employment-mode"
                      v-model="userData.employmentModeId"
                      ref="employmentModeId"
                      :options="filteredEmploymentModes"
                      class="____col-8"
                      :aria-invalid="!!getErrorMessagesForField(errors, 'employmentModeId')"
                      :aria-describedby="getErrorMessagesForField(errors, 'employmentModeId') ? 'employee-employment-mode-error' : null"
                    />
                    <div
                        v-if="getErrorMessagesForField(errors, 'employmentModeId')"
                        id="employee-employment-mode-error"
                        class="text-danger p-2"
                        role="alert"
                    >
                      <i class="fas fa-exclamation-triangle field_employmentModeId" aria-hidden="true"></i>
                      {{ getErrorMessagesForField(errors, 'employmentModeId') }}
                    </div>
                  </div>

                  <div v-if="userData.employmentModeId" class="employee-section-content">

            <div
              :class="{
                hidden: ![2901, 2902, 2903, 2904, 2905, 2906].includes(
                  userData.employmentModeId
                ),
              }"
              class="data-wrapper employee-field-full"
            >
              <h5 class="bold mt-3 employee-field-title">Viselt név</h5>
              <div >
                <b-row>
                  <b-col cols="12" md="3">
                    <b-form-input
                      v-model="userData.currentNameTitle"
                      placeholder="titulus"
                      v-mask="letterFilter"
                      trim
                      autocomplete="off"
                    />
                  </b-col>
                </b-row>
                <b-row>
                  <b-col cols="12" md="6">
                    <b-form-input
                      v-model="userData.currentNameLastName"
                      ref="currentNameLastName"
                      v-mask="letterFilter"
                      placeholder="vezetéknév"
                      trim
                      autocomplete="off"
                    />
                    <div
                        v-if="getErrorMessagesForField(errors, 'currentNameLastName')"
                        class="text-danger p-2"
                    >
                      <i class="fas fa-exclamation-triangle field_currentNameLastName"></i>
                      {{ getErrorMessagesForField(errors, 'currentNameLastName') }}
                    </div>
                  </b-col>
                  <b-col cols="12" md="6">
                    <b-form-input
                      v-model="userData.currentNameFirstName"
                      ref="currentNameFirstName"
                      v-mask="letterFilter"
                      placeholder="keresztnév"
                      autocomplete="off"
                      trim
                    />
                    <div
                        v-if="getErrorMessagesForField(errors, 'currentNameFirstName')"
                        class="text-danger p-2"
                    >
                      <i class="fas fa-exclamation-triangle field_currentNameFirstName"></i>
                      {{ getErrorMessagesForField(errors, 'currentNameFirstName') }}
                    </div>

                  </b-col>
                </b-row>
              </div>
            </div>

            <div
              :class="{
                hidden: ![2901, 2902, 2903, 2904, 2905, 2906].includes(
                  userData.employmentModeId
                ),
              }"
              class="data-wrapper employee-field-full"
            >
              <h5 class="bold mt-3 employee-field-title">Születési név</h5>
              <div >
                <b-row>
                  <b-col cols="12" md="6">
                    <b-form-input
                      v-model="userData.birthNameLastName"
                      ref="birthNameLastName"
                      placeholder="vezetéknév"
                      v-mask="letterFilter"
                      trim
                      autocomplete="off"
                    />
                    <div
                        v-if="getErrorMessagesForField(errors, 'birthNameLastName')"
                        class="text-danger p-2"
                    >
                      <i class="fas fa-exclamation-triangle field_birthNameLastName"></i>
                      {{ getErrorMessagesForField(errors, 'birthNameLastName') }}
                    </div>

                  </b-col>
                  <b-col cols="12" md="6">
                    <b-form-input
                      v-model="userData.birthNameFirstName"
                      ref="birthNameFirstName"
                      v-mask="letterFilter"
                      placeholder="keresztnév"
                      trim
                      autocomplete="off"
                    />
                    <div
                        v-if="getErrorMessagesForField(errors, 'birthNameFirstName')"
                        class="text-danger p-2"
                    >
                      <i class="fas fa-exclamation-triangle field_birthNameFirstName"></i>
                      {{ getErrorMessagesForField(errors, 'birthNameFirstName') }}
                    </div>

                  </b-col>
                </b-row>
              </div>
            </div>

            <div
              :class="{
                hidden: ![2901, 2902, 2903, 2904, 2905, 2906].includes(
                  userData.employmentModeId
                ),
              }"
              class="data-wrapper employee-field-full"
            >
              <h5 class="bold mt-3 employee-field-title">Anyja neve</h5>
              <div >
                <b-row>
                  <b-col cols="12" md="6">
                    <b-form-input
                      v-model="userData.mothersNameLastName"
                      ref="mothersNameLastName"
                      v-mask="letterFilter"
                      placeholder="vezetéknév"
                      trim
                      autocomplete="off"
                    />
                    <div
                        v-if="getErrorMessagesForField(errors, 'mothersNameLastName')"
                        class="text-danger p-2"
                    >
                      <i class="fas fa-exclamation-triangle field_mothersNameLastName"></i>
                      {{ getErrorMessagesForField(errors, 'mothersNameLastName') }}
                    </div>

                  </b-col>
                  <b-col cols="12" md="6">
                    <b-form-input
                      v-model="userData.mothersNameFirstName"
                      ref="mothersNameFirstName"
                      placeholder="keresztnév"
                      v-mask="letterFilter"
                      trim
                      autocomplete="off"
                    />
                    <div
                        v-if="getErrorMessagesForField(errors, 'mothersNameFirstName')"
                        class="text-danger p-2"
                    >
                      <i class="fas fa-exclamation-triangle field_mothersNameFirstName"></i>
                      {{ getErrorMessagesForField(errors, 'mothersNameFirstName') }}
                    </div>

                  </b-col>
                </b-row>
              </div>
            </div>
            <div class="data-wrapper">
              <h5 class="bold mt-3 employee-field-title">Születési hely</h5>
              <b-form-input
                
                v-model="userData.birthPlace"
                ref="birthPlace"
                v-mask="letterFilter"
                class="____col-8"
                trim
                autocomplete="off"
              />
              <div
                  v-if="getErrorMessagesForField(errors, 'birthPlace')"
                  class="text-danger p-2"
              >
                <i class="fas fa-exclamation-triangle field_birthPlace"></i>
                {{ getErrorMessagesForField(errors, 'birthPlace') }}
              </div>

            </div>

            <div class="data-wrapper">
              <h5 class="bold mt-3 employee-field-title">Születési idő</h5>
              <DatePicker
                v-model="userData.birthDate"
                ref="birthDate"
                format="YYYY-MM-DD"
                value-type="format"
                :disabled-date="disableDatesAfterMaximum"
                class="____col-8 employee-date-picker white-input"
              />
              <div
                  v-if="getErrorMessagesForField(errors, 'birthDate')"
                  class="text-danger p-2"
              >
                <i class="fas fa-exclamation-triangle field_birthDate"></i>
                {{ getErrorMessagesForField(errors, 'birthDate') }}
              </div>

            </div>

            <div
              :class="{
                hidden: ![2901, 2902, 2903, 2904, 2905, 2906].includes(
                  userData.employmentModeId
                ),
              }"
              class="data-wrapper"
            >
              <h5 class="bold mt-3 employee-field-title">TAJ szám</h5>
              <b-form-input
                
                v-model="userData.tajNumber"
                ref="tajNumber"
                v-mask="tajFilter"
                class="____col-8"
                trim
                autocomplete="off"
              />
              <div
                v-if="getErrorMessagesForField(errors, 'tajNumber')"
                class="text-danger p-2"
              >
                <i class="fas fa-exclamation-triangle field_tajNumber"></i>
                {{ getErrorMessagesForField(errors, 'tajNumber') }}
              </div>
            </div>

            <div class="data-wrapper">
              <h5 class="bold mt-3 employee-field-title">Nem</h5>
              <Dropdown
                
                v-model="userData.gender"
                ref="gender"
                :options="genderOptions"
                class="____col-8"
              />
              <div
                  v-if="getErrorMessagesForField(errors, 'gender')"
                  class="text-danger p-2"
              >
                <i class="fas fa-exclamation-triangle field_gender"></i>
                {{ getErrorMessagesForField(errors, 'gender') }}
              </div>

            </div>

            <div class="data-wrapper">
              <h5 class="bold mt-3 employee-field-title">Állampolgárság</h5>
              <Dropdown
                
                v-model="userData.citizenship"
                ref="citizenship"
                :options="citizenship"
                class="____col-8"
              />
              <div
                  v-if="getErrorMessagesForField(errors, 'citizenship')"
                  class="text-danger p-2"
              >
                <i class="fas fa-exclamation-triangle field_citizenship"></i>
                {{ getErrorMessagesForField(errors, 'citizenship') }}
              </div>

            </div>

            <div
              :class="{
                hidden: ![2901, 2902, 2903, 2904, 2905, 2906].includes(
                  userData.employmentModeId
                ),
              }"
              class="data-wrapper"
            >
              <h5 class="bold mt-3 employee-field-title">Adóazonosító jel</h5>
              <b-form-input
                
                v-model="userData.taxNumber"
                ref="taxNumber"
                v-mask="taxFilter"
                class="____col-8"
                trim
                autocomplete="off"
              />
              <div
                  v-if="getErrorMessagesForField(errors, 'taxNumber')"
                  class="text-danger p-2"
              >
                <i class="fas fa-exclamation-triangle field_taxNumber"></i>
                {{ getErrorMessagesForField(errors, 'taxNumber') }}
              </div>

            </div>

            <div
              :class="{
                hidden: ![2903].includes(userData.employmentModeId),
              }"
              class="data-wrapper"
            >
              <h5 class="bold mt-3 employee-field-title">Adószám</h5>
              <b-form-input
                
                v-model="userData.evTaxNumber"
                ref="evTaxNumber"
                v-mask="'########-#-##'"
                class="____col-8"
                trim
                autocomplete="off"
              />
              <div
                  v-if="getErrorMessagesForField(errors, 'evTaxNumber')"
                  class="text-danger p-2"
              >
                <i class="fas fa-exclamation-triangle field_evTaxNumber"></i>
                {{ getErrorMessagesForField(errors, 'evTaxNumber') }}
              </div>

            </div>

            <div
              :class="{
                hidden: ![2902, 2903, 2904, 2905, 2906, 2901].includes(
                  userData.employmentModeId
                ),
              }"
              class="data-wrapper"
            >
              <h5 class="bold mt-3 employee-field-title">Lakcím</h5>
              <b-form-input
                
                v-model="userData.address"
                ref="address"
                class="____col-8"
                trim
                autocomplete="off"
                aria-label="Lakcím"
              />
              <div
                  v-if="getErrorMessagesForField(errors, 'address')"
                  class="text-danger p-2"
                  role="alert"
              >
                <i class="fas fa-exclamation-triangle field_address" aria-hidden="true"></i>
                {{ getErrorMessagesForField(errors, 'address') }}
              </div>
            </div>

            <div
              class="data-wrapper"
            >
              <h5 class="bold mt-3 employee-field-title">E-mail</h5>
              <b-form-input
                
                v-model="userData.email"
                ref="email"
                class="____col-8"
                trim
                autocomplete="off"
                aria-label="E-mail"
              />
              <div
                  v-if="getErrorMessagesForField(errors, 'email')"
                  class="text-danger p-2"
                  role="alert"
              >
                <i class="fas fa-exclamation-triangle field_email" aria-hidden="true"></i>
                {{ getErrorMessagesForField(errors, 'email') }}
              </div>
            </div>
                  </div>
                </div>
              </b-collapse>
            </section>

            <div class="employee-right-column">
            <section v-if="userData.employmentModeId" class="employee-section-card" aria-label="Munkaügyi mezők">
              <header class="employee-section-header">
                <h2 id="munkaugyi-heading" class="employee-section-title d-none d-md-block">Munkaügyi mezők</h2>
                <button
                  type="button"
                  class="employee-section-toggle d-md-none"
                  aria-controls="munkaugyi-panel"
                  :aria-expanded="String(munkaugyiOpen)"
                  @click="munkaugyiOpen = !munkaugyiOpen"
                >
                  <span>Munkaügyi mezők</span>
                  <b-icon :icon="munkaugyiOpen ? 'chevron-up' : 'chevron-down'" aria-hidden="true"></b-icon>
                </button>
              </header>

              <b-collapse id="munkaugyi-panel" v-model="munkaugyiOpen" class="employee-section-body">
                <div class="employee-fields-grid">
                  <div class="data-wrapper employee-field-full">
                    <h5 class="bold mt-3 employee-field-title">
                      Bankszámlaszám
                    </h5>
                    <b-form-input

                        v-model="userData.bankAccountNumber"
                        ref="bankAccountNumber"
                        v-mask="bankAccountFilter"
                        class="____col-8"
                        trim
                        autocomplete="off"
                        aria-label="Bankszámlaszám"
                    />
                    <div
                        v-if="getErrorMessagesForField(errors, 'bankAccountNumber')"
                        class="text-danger p-2"
                        role="alert"
                    >
                      <i class="fas fa-exclamation-triangle field_bankAccountNumber" aria-hidden="true"></i>
                      {{ getErrorMessagesForField(errors, 'bankAccountNumber') }}
                    </div>

                  </div>
                  <div
                    :class="{
                      hidden: ![2901].includes(userData.employmentModeId),
                    }"
                    class="data-wrapper"
                  >
                    <h5 class="bold employee-field-title">Munka típusa</h5>
                    <Dropdown
                      
                      v-model="userData.jobTypeId"
                      ref="jobTypeId"
                      :options="jobTypes"
                      class="____col-8"
                      aria-label="Munkaviszony jellege"
                    />
                    <div
                        v-if="getErrorMessagesForField(errors, 'jobTypeId')"
                        class="text-danger p-2"
                        role="alert"
                    >
                      <i class="fas fa-exclamation-triangle field_jobTypeId" aria-hidden="true"></i>
                      {{ getErrorMessagesForField(errors, 'jobTypeId') }}
                    </div>

                  </div>

                  <div
                    :class="{
                      hidden: ![2901].includes(userData.employmentModeId),
                    }"
                    class="data-wrapper"
                  >
                    <h5 class="bold mt-3 employee-field-title">Díjazás</h5>
                    <Dropdown
                      
                      v-model="userData.wageTypeId"
                      ref="wageTypeId"
                      :options="wageTypes"
                      class="____col-8"
                      aria-label="Bérezés formája"
                    />
                    <div
                        v-if="getErrorMessagesForField(errors, 'wageTypeId')"
                        class="text-danger p-2"
                        role="alert"
                    >
                      <i class="fas fa-exclamation-triangle field_wageTypeId" aria-hidden="true"></i>
                      {{ getErrorMessagesForField(errors, 'wageTypeId') }}
                    </div>


                    <div v-if="userData.wageTypeId === 6901">
                      <h5 class="bold mt-3 employee-field-title">Napibér (Ft/nap)</h5>
                      <b-form-input
                        
                        v-model="userData.dailyWage"
                        ref="dailyWage"
                        class="____col-8"
                        v-mask="numberFilter"
                        trim
                        autocomplete="off"
                        aria-label="Napi bér"
                      />
                      <div
                          v-if="getErrorMessagesForField(errors, 'dailyWage')"
                          class="text-danger p-2"
                          role="alert"
                      >
                        <i class="fas fa-exclamation-triangle field_dailyWage" aria-hidden="true"></i>
                        {{ getErrorMessagesForField(errors, 'dailyWage') }}
                      </div>

                    </div>

                    <div v-if="userData.wageTypeId === 6902">
                      <h5 class="bold mt-3 employee-field-title">Órabér (Ft/óra)</h5>
                      <b-form-input
                        
                        v-model="userData.hourlyWage"
                        ref="hourlyWage"
                        class="____col-8"
                        v-mask="numberFilter"
                        trim
                        autocomplete="off"
                        aria-label="Órabér"
                      />
                      <div
                          v-if="getErrorMessagesForField(errors, 'hourlyWage')"
                          class="text-danger p-2"
                          role="alert"
                      >
                        <i class="fas fa-exclamation-triangle field_hourlyWage" aria-hidden="true"></i>
                        {{ getErrorMessagesForField(errors, 'hourlyWage') }}
                      </div>

                    </div>
                  </div>

            <div
              :class="{
                hidden: ![2902, 2903, 2904, 2905, 2906].includes(
                  userData.employmentModeId
                ),
              }"
              class="data-wrapper"
            >
              <h5 class="bold mt-3 employee-field-title">Belépés dátuma</h5>
              <DatePicker
                v-model="userData.entryDate"
                ref="entryDate"
                format="YYYY-MM-DD"
                value-type="format"
                :disabled-date="disableDatesAfterMaximum"
                class="____col-8 employee-date-picker white-input"
              />
              <div
                  v-if="getErrorMessagesForField(errors, 'entryDate')"
                  class="text-danger p-2"
              >
                <i class="fas fa-exclamation-triangle field_entryDate"></i>
                {{ getErrorMessagesForField(errors, 'entryDate') }}
              </div>

            </div>
            <div
              :class="{
                hidden: ![2906].includes(userData.employmentModeId),
              }"
              class="data-wrapper"
            >
              <h5 class="bold mt-3 employee-field-title">
                Megbízás jellege
              </h5>
              <Dropdown
                
                v-model="userData.applimentTypeId"
                ref="applimentTypeId"
                :options="applimentTypes"
                class="____col-8"
              />
              <div
                  v-if="getErrorMessagesForField(errors, 'applimentTypeId')"
                  class="text-danger p-2"
              >
                <i class="fas fa-exclamation-triangle field_applimentTypeId"></i>
                {{ getErrorMessagesForField(errors, 'applimentTypeId') }}
              </div>

            </div>

            <div
              :class="{
                hidden: ![2906].includes(userData.employmentModeId),
              }"
              class="data-wrapper"
            >
              <h5 class="bold mt-3 employee-field-title">
                Megbízási díj
              </h5>
              <b-form-input
                
                v-model="userData.applimentFee"
                ref="applimentFee"
                v-mask="numberFilter"
                class="____col-8"
                trim
                autocomplete="off"
              />
              <div
                  v-if="getErrorMessagesForField(errors, 'applimentFee')"
                  class="text-danger p-2"
              >
                <i class="fas fa-exclamation-triangle field_applimentFee"></i>
                {{ getErrorMessagesForField(errors, 'applimentFee') }}
              </div>

            </div>

            <div
              :class="{
                hidden: ![2905].includes(userData.employmentModeId),
              }"
              class="data-wrapper"
            >
              <h5 class="bold mt-3 employee-field-title">Költségelszámolás módja</h5>
              <Dropdown
                v-model="userData.settlementId"
                ref="settlementId"
                :options="settlementModes"
                class="____col-8"
              />
              <div
                  v-if="getErrorMessagesForField(errors, 'settlementId')"
                  class="text-danger p-2"
              >
                <i class="fas fa-exclamation-triangle field_settlementId"></i>
                {{ getErrorMessagesForField(errors, 'settlementId') }}
              </div>

            </div>

            <div
              :class="{
                hidden: ![2905].includes(userData.employmentModeId),
              }"
              class="data-wrapper"
            >
              <h5 class="bold mt-3 employee-field-title">Rezsi elszámolás módja</h5>
              <b-form-input
                
                v-model="userData.rezsi"
                ref="rezsi"
                class="____col-8"
                trim
                autocomplete="off"
              />
              <div
                  v-if="getErrorMessagesForField(errors, 'rezsi')"
                  class="text-danger p-2"
              >
                <i class="fas fa-exclamation-triangle field_rezsi"></i>
                {{ getErrorMessagesForField(errors, 'rezsi') }}
              </div>

            </div>

            <div
              :class="{
                hidden: ![2905].includes(userData.employmentModeId),
              }"
              class="data-wrapper"
            >
              <h5 class="bold mt-3 employee-field-title">Fizetett bérleti díj</h5>
              <b-form-input
                
                v-model="userData.rentAmmount"
                ref="rentAmmount"
                v-mask="numberFilter"
                class="____col-8"
                trim
                autocomplete="off"
              />
              <div
                  v-if="getErrorMessagesForField(errors, 'rentAmmount')"
                  class="text-danger p-2"
              >
                <i class="fas fa-exclamation-triangle field_rentAmmount"></i>
                {{ getErrorMessagesForField(errors, 'rentAmmount') }}
              </div>

            </div>

            <div
              :class="{
                hidden: ![2903].includes(userData.employmentModeId),
              }"
              class="data-wrapper"
            >
              <h5 class="bold mt-3 employee-field-title">
                Havi kivét
              </h5>
              <b-form-input
                
                v-model="userData.monthlyWithdrawal"
                ref="monthlyWithdrawal"
                v-mask="numberFilter"
                class="____col-8"
                trim
                autocomplete="off"
              />
              <div
                  v-if="getErrorMessagesForField(errors, 'monthlyWithdrawal')"
                  class="text-danger p-2"
              >
                <i class="fas fa-exclamation-triangle field_monthlyWithdrawal"></i>
                {{ getErrorMessagesForField(errors, 'monthlyWithdrawal') }}
              </div>

            </div>

            <div
                      v-if="[2903, 2904].includes(userData.employmentModeId)"
                      class="data-wrapper employee-field-full"
                  >
                    <div class="employee-toggle-row employee-foreign-insurance-toggle">
                      <ToggleSwitch v-model="insuredInOtherCountry" />
                      <span class="employee-toggle-label">Más országban biztosított</span>
                    </div>
                    <div v-if="getErrorMessagesForField(errors, 'foreignInsurancePeriods')" class="text-danger p-2" role="alert">
                      {{ getErrorMessagesForField(errors, 'foreignInsurancePeriods') }}
                    </div>
                    <template v-if="insuredInOtherCountry">
                      <div v-for="(item, index) in userData.foreignInsurancePeriods" :key="index" class="row mb-3">
                        <div class="col-12 col-md-6 p-2">
                          <label :for="`foreign-insurance-category-${index}`" class="mb-1 employee-field-title">Biztosítási terület kategóriája</label>
                          <Dropdown
                              :id="`foreign-insurance-category-${index}`"
                              v-model="item.category"
                              :options="foreignInsuranceCategories"
                              required
                              @input="clearForeignInsuranceCountry(item, $event)"
                          />
                          <div v-if="getIndexedErrorMessage('foreignInsurancePeriods', index, 'category')" class="text-danger p-2" role="alert">
                            {{ getIndexedErrorMessage('foreignInsurancePeriods', index, 'category') }}
                          </div>
                        </div>
                        <div v-if="item.category === 'OTHER_COUNTRY'" class="col-12 col-md-6 p-2">
                          <label :for="`foreign-insurance-country-${index}`" class="mb-1 employee-field-title">Ország</label>
                          <b-form-input :id="`foreign-insurance-country-${index}`" v-model="item.country" trim autocomplete="off" required />
                          <div v-if="getIndexedErrorMessage('foreignInsurancePeriods', index, 'country')" class="text-danger p-2" role="alert">
                            {{ getIndexedErrorMessage('foreignInsurancePeriods', index, 'country') }}
                          </div>
                        </div>
                        <div class="col-12 col-md-6 p-2">
                          <label class="mb-1 employee-field-title">Biztosítás kezdete</label>
                          <DatePicker
                              v-model="item.startDate"
                              format="YYYY-MM-DD"
                              value-type="format"
                              :input-attr="{ 'aria-label': 'Biztosítás kezdete', required: true }"
                              class="employee-date-picker white-input"
                          />
                          <div v-if="getIndexedErrorMessage('foreignInsurancePeriods', index, 'startDate')" class="text-danger p-2" role="alert">
                            {{ getIndexedErrorMessage('foreignInsurancePeriods', index, 'startDate') }}
                          </div>
                        </div>
                        <div class="col-12 col-md-6 p-2">
                          <label class="mb-1 employee-field-title">Biztosítás vége</label>
                          <DatePicker
                              v-model="item.endDate"
                              format="YYYY-MM-DD"
                              value-type="format"
                              :input-attr="{ 'aria-label': 'Biztosítás vége' }"
                              class="employee-date-picker white-input"
                          />
                          <div v-if="getIndexedErrorMessage('foreignInsurancePeriods', index, 'endDate')" class="text-danger p-2" role="alert">
                            {{ getIndexedErrorMessage('foreignInsurancePeriods', index, 'endDate') }}
                          </div>
                        </div>
                        <div class="col-12 p-2">
                          <div v-if="getErrorMessagesForField(errors, `foreignInsurancePeriods[${index}]`)" class="text-danger p-2" role="alert">
                            {{ getErrorMessagesForField(errors, `foreignInsurancePeriods[${index}]`) }}
                          </div>
                          <BaseButton variant="light" size="sm" icon="trash" icon-only aria-label="Biztosítási időszak törlése" @click="removeItem(userData.foreignInsurancePeriods, index)" />
                        </div>
                      </div>
                      <BaseButton variant="light" size="sm" icon="plus" icon-only aria-label="Biztosítási időszak hozzáadása" @click="addForeignInsurancePeriod" />
                    </template>
                  </div>

            <div
              :class="{
                hidden: ![2903, 2904].includes(userData.employmentModeId),
              }"
              class="data-wrapper employee-field-full"
            >
              <div class="employee-toggle-row">
                <ToggleSwitch
                  :model-value="!!userData.workingInOtherCompany"
                  @update:modelValue="userData.workingInOtherCompany = $event"
                />
                <span class="employee-toggle-label">
                  Más cég(ek)ben is van munkaviszonyom
                </span>
              </div>
              <div
                  v-if="getErrorMessagesForField(errors, 'workingInOtherCompany')"
                  class="text-danger p-2"
              >
                <i class="fas fa-exclamation-triangle field_workingInOtherCompany"></i>
                {{ getErrorMessagesForField(errors, 'workingInOtherCompany') }}
              </div>

            </div>

            <div
              :class="{
                hidden:
                  ![2903, 2904].includes(userData.employmentModeId) ||
                  !userData.workingInOtherCompany,
              }"
              class="data-wrapper employee-field-full"
            >
              <div class="employee-toggle-row">
                <ToggleSwitch
                  :model-value="!!userData.workingInOtherCompanyOvertime"
                  @update:modelValue="userData.workingInOtherCompanyOvertime = $event"
                />
                <span class="employee-toggle-label">
                  A heti 36 órát nem haladja meg
                </span>
              </div>
              <div
                  v-if="getErrorMessagesForField(errors, 'workingInOtherCompanyOvertime')"
                  class="text-danger p-2"
              >
                <i class="fas fa-exclamation-triangle field_workingInOtherCompanyOvertime"></i>
                {{ getErrorMessagesForField(errors, 'workingInOtherCompanyOvertime') }}
              </div>

            </div>

            <div
              :class="{
                hidden:
                  ![2903, 2904].includes(userData.employmentModeId) ||
                  !userData.workingInOtherCompanyOvertime ||
                  !userData.workingInOtherCompany,
              }"
              class="data-wrapper"
            >
              <h5 class="bold mt-3 employee-field-title">
                Foglalkoztatás óraszáma
                <button
                  v-b-popover.html.top.click="workingTimePopoverContent"
                  class="btn btn-transparent p-0 m-0 employee-field-info"
                  type="button"
                  aria-label="Foglalkoztatás óraszáma információ"
                  @click.stop
                >
                  <i class="fal fa-info-circle" aria-hidden="true"></i>
                </button>
              </h5>
              <b-form-input
                
                v-model="userData.workingInOtherCompanyTime"
                ref="workingInOtherCompanyTime"
                class="____col-8"
                trim
                autocomplete="off"
              />
              <div
                  v-if="getErrorMessagesForField(errors, 'workingInOtherCompanyTime')"
                  class="text-danger p-2"
              >
                <i class="fas fa-exclamation-triangle field_workingInOtherCompanyTime"></i>
                {{ getErrorMessagesForField(errors, 'workingInOtherCompanyTime') }}
              </div>

            </div>

            <div
              :class="{
                hidden: ![2902].includes(userData.employmentModeId),
              }"
              class="data-wrapper"
            >
              <h5 class="bold mt-3 employee-field-title">Beosztás rendje</h5>
              <Dropdown
                
                v-model="userData.workPostId"
                ref="workPostId"
                :options="workPosts"
                class="____col-8"
              />
              <div
                  v-if="getErrorMessagesForField(errors, 'workPostId')"
                  class="text-danger p-2"
              >
                <i class="fas fa-exclamation-triangle field_workPostId"></i>
                {{ getErrorMessagesForField(errors, 'workPostId') }}
              </div>

            </div>

            <div
              :class="{
                hidden: ![2902].includes(userData.employmentModeId),
              }"
              class="data-wrapper"
            >
              <h5 class="bold mt-3 employee-field-title">
                Alkalmazás formája
              </h5>
              <Dropdown
                v-model="userData.applicationFormId"
                ref="applicationFormId"
                :options="applicationForms"
                class="____col-8"
              />
              <div
                  v-if="getErrorMessagesForField(errors, 'applicationFormId')"
                  class="text-danger p-2"
              >
                <i class="fas fa-exclamation-triangle field_applicationFormId"></i>
                {{ getErrorMessagesForField(errors, 'applicationFormId') }}
              </div>

            </div>

            <div
              :class="{
                hidden:
                  ![2902].includes(userData.employmentModeId) ||
                  userData.applicationFormId !== 3106,
              }"
              class="data-wrapper"
            >
              <h5 class="bold mt-3 employee-field-title">
                Részmunkaidő gyakorisága
              </h5>
              <Dropdown
                
                v-model="userData.partTimeFrequencyId"
                ref="partTimeFrequencyId"
                :options="partTimeFrequencies"
                class="____col-8"
              />
              <div
                  v-if="getErrorMessagesForField(errors, 'partTimeFrequencyId')"
                  class="text-danger p-2"
              >
                <i class="fas fa-exclamation-triangle field_partTimeFrequencyId"></i>
                {{ getErrorMessagesForField(errors, 'partTimeFrequencyId') }}
              </div>

            </div>

            <div
              :class="{
                hidden:
                  ![2902].includes(userData.employmentModeId) ||
                   ![3101, 3105, 3106].includes(userData.applicationFormId) ||
                  (userData.applicationFormId == 3106 && userData.partTimeFrequencyId !== 3501),
              }"
              class="data-wrapper"
            >
              <h5 class="bold mt-3 employee-field-title">Munkaidő</h5>
              <Dropdown
                v-model="userData.workingTimeId"
                ref="workingTimeId"
                :options="workingTimes"
                class="____col-8"
              />
              <div
                  v-if="getErrorMessagesForField(errors, 'workingTimeId')"
                  class="text-danger p-2"
              >
                <i class="fas fa-exclamation-triangle field_workingTimeId"></i>
                {{ getErrorMessagesForField(errors, 'workingTimeId') }}
              </div>

            </div>

            <div
              :class="{
                hidden:
                  ![2902].includes(userData.employmentModeId) ||
                  userData.applicationFormId !== 3106 ||
                  userData.partTimeFrequencyId !== 3502,
              }"
              class="data-wrapper"
            >
              <h5 class="bold mt-3 employee-field-title">Munkaidő</h5>
              <b-form-input
                
                v-model="userData.workingTimeText"
                ref="workingTimeText"
                class="____col-8"
                trim
                autocomplete="off"
              />
              <div
                  v-if="getErrorMessagesForField(errors, 'workingTimeText')"
                  class="text-danger p-2"
              >
                <i class="fas fa-exclamation-triangle field_workingTimeText"></i>
                {{ getErrorMessagesForField(errors, 'workingTimeText') }}
              </div>

            </div>

            <div
              :class="{
                hidden: ![2902].includes(userData.employmentModeId),
              }"
              class="data-wrapper"
            >
              <h5 class="bold mt-3 employee-field-title">Bérezés formája</h5>
              <Dropdown
                
                v-model="userData.paymentModeId"
                ref="paymentModeId"
                :options="paymentModes"
                class="____col-8"
              />
              <div
                  v-if="getErrorMessagesForField(errors, 'paymentModeId')"
                  class="text-danger p-2"
              >
                <i class="fas fa-exclamation-triangle field_paymentModeId"></i>
                {{ getErrorMessagesForField(errors, 'paymentModeId') }}
              </div>

            </div>

            <div
             :class="{
                 hidden: ![2902].includes(userData.employmentModeId),
              }"
              class="data-wrapper"
            >
              <h5 class="bold mt-3 employee-field-title">Munkaidő keret</h5>
              <Dropdown
                
                v-model="userData.workTimeId"
                ref="workTimeId"
                :options="workTimes"
                class="____col-8"
              />
              <div
                  v-if="getErrorMessagesForField(errors, 'workTimeId')"
                  class="text-danger p-2"
              >
                <i class="fas fa-exclamation-triangle field_workTimeId"></i>
                {{ getErrorMessagesForField(errors, 'workTimeId') }}
              </div>

            </div>

            <div
              :class="{
                hidden: ![2902, 2904, 2901].includes(userData.employmentModeId),
              }"
              class="data-wrapper employee-field-full"
            >
              <h5 class="bold mt-3 employee-field-sub-title">Költséghely</h5>
              <BaseButton
                v-if="userData.costCentres.length === 0"
                variant="light"
                size="sm"
                class="m-2"
                icon="plus"
                icon-only
                @click="addNewRow('costCentres')"
              />
              <div class="____col-8 pl-2" >
                <div class="mb-3" v-for="(item, index) in userData.costCentres" :key="index">
                  <div class="row">
                    <div class="col-6 p-2">
                      <label class="mb-1 employee-field-title">Kezdete</label>
                      <DatePicker
                        v-model="item.startDate"
                        format="YYYY-MM-DD"
                        value-type="format"
                        class="employee-date-picker white-input"
                      />
                      <div
                          v-if="getIndexedErrorMessage('costCentres', index, 'startDate')"
                          class="text-danger p-2"
                      >
                        <i class="fas fa-exclamation-triangle field_costCentres_startDate"></i>
                        {{ getIndexedErrorMessage('costCentres', index, 'startDate') }}
                      </div>
                    </div>
                    <div class="col-6 p-2">
                      <label class="mb-1 employee-field-title">Vége</label>
                      <DatePicker
                        v-model="item.endDate"
                        format="YYYY-MM-DD"
                        value-type="format"
                        class="employee-date-picker white-input"
                      />
                      <div
                          v-if="getIndexedErrorMessage('costCentres', index, 'endDate')"
                          class="text-danger p-2"
                      >
                        <i class="fas fa-exclamation-triangle field_costCentres_endDate"></i>
                        {{ getIndexedErrorMessage('costCentres', index, 'endDate') }}
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-6 p-2">
                      <b-form-input
                        v-model="item.costCentre"
                        trim
                        autocomplete="off"
                      />
                      <div
                          v-if="getIndexedErrorMessage('costCentres', index, 'costCentre')"
                          class="text-danger p-2"
                      >
                        <i class="fas fa-exclamation-triangle field_costCentres_costCentre"></i>
                        {{ getIndexedErrorMessage('costCentres', index, 'costCentre') }}
                      </div>
                    </div>
                    <div class="col-6 employee-action-column employee-action-column-no-label justify-content-end">
                      <BaseButton variant="light" size="sm" class="m-1" icon="trash" icon-only @click="removeItem(userData.costCentres, index)" />
                      <BaseButton
                        v-if="index === userData.costCentres.length - 1"
                        variant="light"
                        size="sm"
                        class="m-1"
                        icon="plus"
                        icon-only
                        @click="addNewRow('costCentres')"
                      />
                    </div>
                  </div>
                </div>
              </div>

              <div
                  v-if="getErrorMessagesForField(errors, 'costCentres')"
                  class="text-danger p-2"
              >
                <i class="fas fa-exclamation-triangle field_costCentres"></i>
                {{ getErrorMessagesForField(errors, 'costCentres') }}
              </div>

            </div>

            <div
              :class="{
                hidden: ![2902, 2904].includes(userData.employmentModeId),
              }"
              class="data-wrapper employee-field-full"
            >
              <h5 class="bold mt-3 employee-field-sub-title">
                Bruttó bér
              </h5>
              <BaseButton
                v-if="userData.wageWithTaxes.length === 0"
                variant="light"
                size="sm"
                class="m-2"
                icon="plus"
                icon-only
                @click="addNewRow('wageWithTaxes')"
              />
              <div class="____col-8 pl-2" >
                <div class="mb-3" v-for="(item, index) in userData.wageWithTaxes" :key="index">
                  <div class="row">
                    <div class="col-12 col-md-4 p-2">
                      <label class="mb-1 employee-field-title">Dátum</label>
                      <DatePicker
                        v-model="item.startDate"
                        format="YYYY-MM-DD"
                        value-type="format"
                        class="employee-date-picker white-input"
                      />
                      <div
                          v-if="getIndexedErrorMessage('wageWithTaxes', index, 'startDate')"
                          class="text-danger p-2"
                      >
                        <i class="fas fa-exclamation-triangle field_wageWithTaxes_startDate"></i>
                        {{ getIndexedErrorMessage('wageWithTaxes', index, 'startDate') }}
                      </div>
                    </div>
                    <div class="col-12 col-md-4 p-2">
                      <label class="mb-1 employee-field-title">Bér</label>
                      <b-form-input
                        v-model="item.value"
                        v-mask="numberFilter"
                        trim
                        autocomplete="off"
                      />
                      <div
                          v-if="getIndexedErrorMessage('wageWithTaxes', index, 'value')"
                          class="text-danger p-2"
                      >
                        <i class="fas fa-exclamation-triangle field_wageWithTaxes_value"></i>
                        {{ getIndexedErrorMessage('wageWithTaxes', index, 'value') }}
                      </div>
                    </div>
                    <div class="col-12 col-md-4 employee-action-column justify-content-start">
                      <BaseButton variant="light" size="sm" class="m-1" icon="trash" icon-only @click="removeItem(userData.wageWithTaxes, index)" />
                      <BaseButton
                        v-if="index === userData.wageWithTaxes.length - 1"
                        variant="light"
                        size="sm"
                        class="m-1"
                        icon="plus"
                        icon-only
                        @click="addNewRow('wageWithTaxes')"
                      />
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-8 p-2">
                      <label class="mb-1 employee-field-title">Bér jogcíme</label>
                      <Dropdown
                        v-model="item.earningType"
                        :options="earningTypeOptions"
                      />
                      <div
                          v-if="getIndexedErrorMessage('wageWithTaxes', index, 'earningType')"
                          class="text-danger p-2"
                      >
                        <i class="fas fa-exclamation-triangle field_wageWithTaxes_earningType"></i>
                        {{ getIndexedErrorMessage('wageWithTaxes', index, 'earningType') }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div
                  v-if="getErrorMessagesForField(errors, 'wageWithTaxes')"
                  class="text-danger p-2"
              >
                <i class="fas fa-exclamation-triangle field_wageWithTaxes"></i>
                {{ getErrorMessagesForField(errors, 'wageWithTaxes') }}
              </div>

            </div>

            <div
              :class="{
                hidden: ![2902].includes(userData.employmentModeId),
              }"
              class="data-wrapper employee-field-full"
            >
              <h5 class="bold mt-3 employee-field-sub-title">FEOR szám</h5>
              <BaseButton
                v-if="userData.feors.length === 0"
                variant="light"
                size="sm"
                class="m-2"
                icon="plus"
                icon-only
                @click="addNewRow('feors')"
              />
              <div class="____col-8 pl-2" >
                <div class="mb-3" v-for="(item, index) in userData.feors" :key="index">
                  <div class="row">
                    <div class="col-12 col-md-4 p-2">
                      <label class="mb-1 employee-field-title">Kezdete</label>
                      <DatePicker
                          v-model="item.startDate"
                          format="YYYY-MM-DD"
                          value-type="format"
                          class="employee-date-picker white-input"
                      />
                      <div
                          v-if="getIndexedErrorMessage('feors', index, 'startDate')"
                          class="text-danger p-2"
                      >
                        <i class="fas fa-exclamation-triangle field_feors_startDate"></i>
                        {{ getIndexedErrorMessage('feors', index, 'startDate') }}
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-12 col-md-8 p-2">
                      <DropDownSearch
                        v-if="feorCodes.length"
                        v-model="item.feorId"
                        :external-option-list="feorCodes"
                        :options="feorSearchOptions"
                        placeholder=""
                      />
                      <div
                          v-if="getIndexedErrorMessage('feors', index, 'feorId')"
                          class="text-danger p-2"
                      >
                        <i class="fas fa-exclamation-triangle field_feors_feorId"></i>
                        {{ getIndexedErrorMessage('feors', index, 'feorId') }}
                      </div>
                    </div>
                    <div class="col-12 col-md-4 employee-action-column employee-action-column-no-label justify-content-start">
                      <BaseButton variant="light" size="sm" class="m-1" icon="trash" icon-only @click="removeItem(userData.feors, index)" />
                      <BaseButton
                        v-if="index === userData.feors.length - 1"
                        variant="light"
                        size="sm"
                        class="m-1"
                        icon="plus"
                        icon-only
                        @click="addNewRow('feors')"
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div
                  v-if="getErrorMessagesForField(errors, 'feors')"
                  class="text-danger p-2"
              >
                <i class="fas fa-exclamation-triangle field_feors"></i>
                {{ getErrorMessagesForField(errors, 'feors') }}
              </div>

            </div>
                </div>
              </b-collapse>
            </section>
            <section
              :class="{
                hidden: ![2902, 2903, 2904, 2906].includes(
                  userData.employmentModeId
                ),
              }"
              class="employee-section-card employee-circumstances-section"
              aria-label="Egyéb módosító körülmény"
            >
              <header class="employee-section-header">
                <h2 id="circumstances-heading" class="employee-section-title d-none d-md-block">Egyéb módosító körülmény</h2>
                <button
                  type="button"
                  class="employee-section-toggle d-md-none"
                  aria-controls="circumstances-panel"
                  :aria-expanded="String(circumstancesOpen)"
                  @click="circumstancesOpen = !circumstancesOpen"
                >
                  <span>Egyéb módosító körülmény</span>
                  <b-icon :icon="circumstancesOpen ? 'chevron-up' : 'chevron-down'" aria-hidden="true"></b-icon>
                </button>
              </header>

              <b-collapse id="circumstances-panel" v-model="circumstancesOpen" class="employee-section-body">
                <div
                    v-if="getErrorMessagesForField(errors, 'circumstances')"
                    class="text-danger p-2"
                >
                  <i class="fas fa-exclamation-triangle field_circumstances"></i>
                  {{ getErrorMessagesForField(errors, 'circumstances') }}
                </div>

                <BaseButton
                  v-if="userData.circumstances.length === 0"
                  variant="light"
                  size="sm"
                  class="m-2"
                  icon="plus"
                  icon-only
                  @click="addNewRow('circumstances')"
                />
                <div class="____col-8 pl-2" >
                  <div class="mb-3" v-for="(item, index) in userData.circumstances" :key="index">
                    <div class="row">
                      <div class="col-8">
                        <div class="row">
                          <div class="col-6 p-2">
                            <label class="mb-1 employee-field-title">Kezdete</label>
                            <DatePicker
                              v-model="item.startDate"
                              format="YYYY-MM-DD"
                              value-type="format"
                              required
                              class="employee-date-picker white-input"
                            />
                            <div
                                v-if="getIndexedErrorMessage('circumstances', index, 'startDate')"
                                class="text-danger p-2"
                            >
                              <i class="fas fa-exclamation-triangle field_circumstances_startDate"></i>
                              {{ getIndexedErrorMessage('circumstances', index, 'startDate') }}
                            </div>
                          </div>
                          <div class="col-6 p-2">
                            <label class="mb-1 employee-field-title">Vége</label>
                            <DatePicker
                              v-model="item.endDate"
                              format="YYYY-MM-DD"
                              value-type="format"
                              class="employee-date-picker white-input"
                            />
                            <div
                                v-if="getIndexedErrorMessage('circumstances', index, 'endDate')"
                                class="text-danger p-2"
                            >
                              <i class="fas fa-exclamation-triangle field_circumstances_endDate"></i>
                              {{ getIndexedErrorMessage('circumstances', index, 'endDate') }}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-4 p-2">
                        <Dropdown
                          v-model="item.circumstanceType"
                          :options="circumstancesOptions"
                        />
                        <div
                            v-if="getIndexedErrorMessage('circumstances', index, 'circumstanceType')"
                            class="text-danger p-2"
                        >
                          <i class="fas fa-exclamation-triangle field_circumstances_circumstanceType"></i>
                          {{ getIndexedErrorMessage('circumstances', index, 'circumstanceType') }}
                        </div>
                      </div>
                      <div class="col-4 p-2">
                        <Dropdown
                          v-if="item.circumstanceType === 3701 || item.circumstanceType === 3702"
                          v-model="item.specificType"
                          :options="item.circumstanceType === 3701 ? circumstancesStudentSpecificOptions : circumstancesRetirementSpecificOptions"
                        />
                        <div
                            v-if="getIndexedErrorMessage('circumstances', index, 'specificType')"
                            class="text-danger p-2"
                        >
                          <i class="fas fa-exclamation-triangle field_circumstances_specificType"></i>
                          {{ getIndexedErrorMessage('circumstances', index, 'specificType') }}
                        </div>
                      </div>
                      <div class="col-4 employee-action-column employee-action-column-no-label">
                        <BaseButton variant="light" size="sm" class="m-1" icon="trash" icon-only @click="removeItem(userData.circumstances, index)" />
                        <BaseButton
                          v-if="index === userData.circumstances.length - 1"
                          variant="light"
                          size="sm"
                          class="m-1"
                          icon="plus"
                          icon-only
                          @click="addNewRow('circumstances')"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </b-collapse>
            </section>
            </div>
          </div>
        </b-col>
      </b-row>
    </b-container>
    <div v-if="isFormDirty && userData.employmentModeId" class="employee-floating-save-bar">
      <BaseButton
        variant="success"
        label="Mentés"
        :disabled="isSaving"
        @click="save"
      />
    </div>

  </div>
</template>

<script>
import Api from "@/api/server/index";
import Util from "@/utils/Util";
import { mapGetters } from "vuex";
import {getErrorMessagesForField} from "@/utils/CommonLogic";
import DropDownSearch from "@/components/DropDownSearch.vue";
import Dropdown from "@/components/Dropdown.vue";
import BaseButton from "@/components/BaseButton.vue";
import ToggleSwitch from "@/components/ToggleSwitch.vue";
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
import "vue2-datepicker/locale/hu";

export default {
  name: "EditEmployee",
  components: {BaseButton, DatePicker, Dropdown, DropDownSearch, ToggleSwitch},

  props: {
    employeeId: Number,
  },

  computed: {
    ...mapGetters("app", ["getActiveCompany"]),

    insuredInOtherCountry: {
      get() {
        return (this.userData.foreignInsurancePeriods || []).length > 0;
      },
      set(enabled) {
        if (enabled) {
          if (!this.insuredInOtherCountry) this.addForeignInsurancePeriod();
        } else {
          this.userData.foreignInsurancePeriods = [];
        }
      },
    },

    filteredEmploymentModes() {
      let result = this.employmentModes;
      result = result.filter(
        (r) =>
          (this.userData.employeeType === "FIX" && r.value !== 2901) ||
          (this.userData.employeeType === "TEMPORARY" && r.value === 2901)
      );
      return result;
    },
  },
  data() {
    return {
      warningMessage: "",
      evIdList: [],
      company: {},
      letterFilter: "CCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCC",
      taxFilter: "##########",
      tajFilter: "###-###-###",
      numberFilter: "##################################################",
      bankAccountFilter: "########-########-########",
      employmentModes: [],
      jobTypes: [],
      workPosts: [],
      applicationForms: [],
      paymentModes: [],
      workTimes: [],
      applimentTypes: [],
      feorCodes: [],
      feorSearchOptions: {
        filteredAttr: "searchText",
        formatOption: (item) => item.text,
        formatText: (item) => item.text,
        minimumInputLength: 0,
        returnValue: "value",
      },
      wageTypes: [],
      periodOfPermissions: [
        { value: 0, text: "Állandó" },
        { value: 1, text: "Ideiglenes" },
      ],
      partTimeFrequencies: [],
      workingTimes: [],
      settlementModes: [],
      citizenship: [],
      genderOptions: [
        { value: 2, text: "Nő" },
        { value: 1, text: "Férfi" },
      ],
      earningTypeOptions: [
        { value: null, text: "-" },
        { value: "BASE_SALARY", text: "Alapbér" },
        { value: "FIXED_ALLOWANCE", text: "Pótlékátalány" },
        { value: "PERFORMANCE_PAY", text: "Teljesítménybér" },
      ],
      foreignInsuranceCategories: [
        { value: null, text: "-" },
        { value: "EGT", text: "EGT" },
        { value: "OTHER_COUNTRY", text: "Más országban" },
      ],
      userData: {
        id: this.$route.params.employeeId,
        employeeType: this.$route.params.type,
        companyId: this.$route.params.companyId,
        feors: [],
        circumstances: [],
        foreignInsurancePeriods: [],
        costCentres: [],
        wageWithTaxes: [],
      },
      employeeExits: {},
      torzsadatOpen: !this.isMobile(),
      munkaugyiOpen: !this.isMobile(),
      costCentresIsOpen: false,
      wageWithTaxesIsOpen: false,
      feorsIsOpen: false,
      circumstancesOpen: !this.isMobile(),
      circumstancesOptions: [],
      circumstancesRetirementSpecificOptions: [],
      circumstancesStudentSpecificOptions: [],
      errors: [],
      formSnapshot: "",
      isFormDirty: false,
      isSaving: false,
      workingTimePopoverContent:
        '<div>A másik cég(ek)nél történő heti munkavégzés óraszáma.</div>',
    };
  },

  watch: {
    userData: {
      deep: true,
      handler() {
        if (!this.formSnapshot) {
          return;
        }

        this.isFormDirty = this.getUserDataSnapshot() !== this.formSnapshot;
      },
    },
  },

  methods: {
    getErrorMessagesForField,
    disableDatesAfterMaximum(date) {
      return date > new Date(2999, 11, 31);
    },
    getUserDataSnapshot() {
      return JSON.stringify(this.userData);
    },
    markFormClean() {
      this.formSnapshot = this.getUserDataSnapshot();
      this.isFormDirty = false;
    },
    getIndexedErrorMessage(arrayName, index, fieldName) {
      return getErrorMessagesForField(
        this.errors,
        `${arrayName}[${index}].${fieldName}`
      );
    },

    addNewRow(arrayName) {
      const newRow = {
        startDate: new Date().toISOString().substr(0, 10), // current date in 'YYYY-MM-DD' format
        value: null
      };

      if (arrayName === "wageWithTaxes") {
        newRow.earningType = null;
      }

      if (arrayName === "costCentres") {
        newRow.costCentre = "";
        newRow.endDate = null;
        delete newRow.value;
      }

      this.userData[arrayName].push(newRow);
    },

    addForeignInsurancePeriod() {
      this.userData.foreignInsurancePeriods.push({
        category: null,
        country: null,
        startDate: null,
        endDate: null,
      });
    },

    clearForeignInsuranceCountry(period, category) {
      if (category === "EGT") this.$set(period, "country", null);
    },

    removeItem(array, index) {
      array.splice(index, 1);
    },

    navigateBack() {
      let url = "/app/employee/list";
      this.$router.push(url);
    },

    save(ignoreWarning) {
      if (this.isSaving) {
        return;
      }

      // circumstance validation
      if (this.userData.circumstances && this.userData.circumstances.some(item => (item.startDate && !('circumstanceType' in item)) || ((item.circumstanceType === 3701 || item.circumstanceType === 3702) && !('specificType' in item)))) {
        this.$toast.error({
          title: "Hiba",
          message: "Hiányosan kitöltött módosító körülmények!",
        });
        return;
      }

      this.isSaving = true;
      this.userData.foreignInsurancePeriods = this.userData.foreignInsurancePeriods.map(period => ({
        ...period,
        country: period.category === "EGT" ? null : period.country,
        startDate: period.startDate || null,
        endDate: period.endDate || null,
      }));
      Api.uploadEmployee(this.userData, ignoreWarning)
        .then(() => {
          this.$toast.success({
            title: "Siker",
            message: "Sikeres hozzáadás",
          });
          this.errors = [];
          this.markFormClean();
          this.navigateBack();
        })
        .catch((err) => {
          this.$toast.error({
            title: "Hiba",
            message: "Sikertelen hozzáadás",
          });
          this.errors = err.response.data;
          console.log(err)
          if (Util.isOnlyWarning(err)) {
            // this.warningMessage = Util.getFirstValidationMessage(err);
            // this.$refs.saveWarning.show();
          }
          this.isSaving = false;
          //
          // Util.clearValidationErrors(
          //   document.getElementById("new-employee-container")
          // );
          // Util.showValidationErrors(err, this.$refs);
        });
    },

    isMobile() {
      return window.innerWidth <= 768;
    },

    closeAllPopovers(event) {
      if (!event.target.closest('[v-b-popover]')) {
        this.$root.$emit('bv::hide::popover');
      }
    },

    loadDictionaries() {
      this.loadDictionary(Api.getEmploymentModes, this.employmentModes);
      this.loadDictionary(Api.getJobTypes, this.jobTypes);
      this.loadDictionary(Api.getWorkPosts, this.workPosts);
      this.loadDictionary(Api.getApplicationForms, this.applicationForms);
      this.loadDictionary(Api.getPaymentModes, this.paymentModes);
      this.loadDictionary(Api.getWorkTimes, this.workTimes);
      this.loadDictionary(Api.getPartTimeFrequencies, this.partTimeFrequencies);
      this.loadDictionary(Api.getWorkingTimes, this.workingTimes);
      this.loadDictionary(Api.getSettlementModes, this.settlementModes);
      this.loadDictionaryAndOrder(Api.getCitizenship, this.citizenship);
      this.loadDictionary(Api.getWageTypes, this.wageTypes);
      this.loadDictionary(Api.getCircumstances, this.circumstancesOptions);
      this.loadDictionary(Api.getRetirementTypes, this.circumstancesRetirementSpecificOptions);
      this.loadDictionary(Api.getStudentTypes, this.circumstancesStudentSpecificOptions);

      Api.getFeorCodes()
        .then((data) => {
          let feors = data.data.sort((a, b) => a.code - b.code);

          feors.forEach((item) => { 
            if (item.code && String(item.code).length >= 4) {
              const text = item.code + " - " + item.nameHu;
              this.feorCodes.push({ value: item.id, text, searchText: text })
            }
          });
        })
        .catch((err) => console.error(err));

      this.loadDictionary(Api.getAppimentTypes, this.applimentTypes);
    },

    loadDictionary(api, target) {
      api()
        .then((data) => {
          data.data.content.forEach((item) =>
            target.push({ value: item.id, text: this.$cte(item.name) })
          );
        })
        .catch((err) => console.error(err));
    },

    loadDictionaryAndOrder(api, target) {
      api()
          .then((data) => {
            data.data.content.sort((a, b) => a.name.toLowerCase().localeCompare(b.name.toLowerCase()));
            data.data.content.forEach((item) => {
              target.push({value: item.id, text: this.$cte(item.name)});
            });
          })
          .catch((err) => console.error(err));
    },

    applyFormAccessibility() {
      const root = this.$el && this.$el.querySelector("#new-employee-container");
      if (!root) {
        return;
      }

      const foreignInsuranceToggle = root.querySelector(".employee-foreign-insurance-toggle input");
      if (foreignInsuranceToggle) {
        foreignInsuranceToggle.setAttribute("aria-label", "Más országban biztosított");
      }

      root.querySelectorAll(".data-wrapper").forEach((wrapper) => {
        const heading = wrapper.querySelector("h5, .employee-field-label");
        const baseLabel = heading
          ? heading.textContent.replace(/\s+/g, " ").replace(/:$/, "").trim()
          : "";
        const controls = wrapper.querySelectorAll("input, select, textarea, .ui.selection.dropdown");

        controls.forEach((control, index) => {
          if (!control.getAttribute("aria-label") && baseLabel) {
            const placeholder = control.getAttribute("placeholder");
            const label = placeholder
              ? `${baseLabel} - ${placeholder}`
              : controls.length > 1
                ? `${baseLabel} ${index + 1}`
                : baseLabel;
            control.setAttribute("aria-label", label);
          }
        });

        wrapper.querySelectorAll(".text-danger").forEach((message) => {
          if (!message.getAttribute("role")) {
            message.setAttribute("role", "alert");
          }
        });

        wrapper.querySelectorAll(".fa-exclamation-triangle, svg").forEach((icon) => {
          if (!icon.closest("button")) {
            icon.setAttribute("aria-hidden", "true");
          }
        });
      });

      root.querySelectorAll("button").forEach((button) => {
        const text = button.textContent.replace(/\s+/g, " ").trim();
        if (!text && !button.getAttribute("aria-label")) {
          const wrapper = button.closest(".data-wrapper");
          const heading = wrapper && wrapper.querySelector("h5");
          const baseLabel = heading
            ? heading.textContent.replace(/\s+/g, " ").replace(/:$/, "").trim()
            : "Űrlap";
          button.setAttribute("aria-label", `${baseLabel} művelet`);
        }
      });
    },
  },

  async mounted() {

    this.company = await Api.getCompany(this.getActiveCompany.id).then(
      (resp) => resp.data
    );

    // console.log(this.company)
    this.evIdList = await Api.getEvIdList(this.getActiveCompany.id).then(
      (resp) => resp.data
    );

    if (this.employeeId) {
      try {
        this.userData = await Api.getEmployeeById(this.employeeId).then(
            (resp) => resp.data
        );
        this.$set(this.userData, "foreignInsurancePeriods", this.userData.foreignInsurancePeriods || []);
        if (!this.userData.costCentres) {
          this.userData.costCentres = [];
        }
        this.loadDictionaries();
      } catch (err) {
        this.$toast.error({
          title: "Hiba",
          message: "Hiba",
        });
      }
    } else {
      this.loadDictionaries();
    }

    if (this.company.taxNumber && !this.userData.evTaxNumber) {
      this.userData.evTaxNumber = this.company.taxNumber;
    }

    this.$nextTick(this.applyFormAccessibility);
    this.$nextTick(this.markFormClean);

    document.addEventListener('click', this.closeAllPopovers, true);
  },

  beforeDestroy() {
    document.removeEventListener('click', this.closeAllPopovers, true);
  },

  updated() {
    this.$nextTick(this.applyFormAccessibility);
  },
};
</script>

<style scoped>
.is-invalid {
  background-color: #f9e2e2 !important;
}

.bold {
  font-weight: bold;
}

.hidden {
  display: none !important;
}

#new-employee-container.employee-torzsadat {
  color: #252734;
  padding-left: 0;
  padding-right: 0;
}

.employee-layout {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 24px;
  align-items: start;
}

.employee-right-column {
  display: flex;
  flex-direction: column;
  gap: 24px;
}

.employee-section-card {
  border: 1px solid #AEBFC7;
  border-radius: 32px;
  background: rgba(255, 255, 255, 0.74);
  box-shadow: 0 20px 40px rgba(37, 39, 52, 0.08);
  padding: 28px;
}

.employee-section-header {
  margin-bottom: 15px;
}

.employee-section-title {
  color: #252734;
  font-family: JumperBold;
  font-size: 24px;
  line-height: 1.2;
  margin: 0;
}

.employee-section-toggle {
  align-items: center;
  background: transparent;
  border: 0;
  color: #252734;
  display: flex;
  font-family: JumperBold;
  font-size: 22px;
  justify-content: space-between;
  padding: 0;
  text-align: left;
  width: 100%;
}

.employee-section-toggle:focus {
  border-radius: 16px;
  box-shadow: 0 0 0 3px rgba(178, 236, 93, 0.7);
  outline: none;
}

.employee-fields-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 10px 20px;
}

.employee-section-content {
  display: contents;
}

.employee-field-full {
  grid-column: 1 / -1;
}

.employee-circumstances-section {
  width: 100%;
}

.card-body {
  padding: 0 !important;
}

.data-wrapper {
  min-height: auto;
}

.employee-field-title {
  color: #252734;
  display: block;
  font-family: JumperBold;
  font-size: 12px;
  line-height: 1.25;
  margin: 0 0 8px !important;
  padding-left: 20px;
}

.employee-field-info {
  color: #252734;
  line-height: 1;
  margin-left: 6px !important;
  vertical-align: middle;
}

.employee-field-info:focus {
  box-shadow: none !important;
  outline: none !important;
}

.popover {
  max-width: 350px !important;
  width: 450px !important;
  border-radius: 32px !important;
  padding: 14px;
}

.employee-toggle-row {
  align-items: center;
  display: flex;
  gap: 12px;
  margin-top: 2px;
  margin-left: 14px;
}

.data-wrapper .employee-toggle-row .employee-toggle-label {
  color: #252734;
  font-family: JumperThin;
  font-size: 12px;
  line-height: 1.25;
}

.employee-field-sub-title {
  color: #252734;
  display: block;
  font-family: JumperBold;
  font-size: 18px;
  line-height: 1.25;
  margin: 0 0 8px !important;
  padding-left: 10px;
}

.data-wrapper span {
  font-family: JumperThin;
}

#new-employee-container.employee-torzsadat input,
#new-employee-container.employee-torzsadat select,
#new-employee-container.employee-torzsadat .custom-select {
  background-color: #ffffff !important;
  border: 1px solid #AEBFC7 !important;
  border-radius: 32px !important;
  box-shadow: 0 10px 24px rgba(37, 39, 52, 0.09) !important;
  color: #252734 !important;
  font-family: Poppins, sans-serif !important;
  font-size: 12px !important;
  font-weight: 400 !important;
  min-height: 42px;
  width: 100% !important;
}

#new-employee-container.employee-torzsadat input::placeholder,
#new-employee-container.employee-torzsadat select option,
#new-employee-container.employee-torzsadat .custom-select .text,
#new-employee-container.employee-torzsadat .dropdown-select .select-text {
  font-family: Poppins, sans-serif !important;
  font-weight: 400 !important;
}

#new-employee-container.employee-torzsadat input:focus,
#new-employee-container.employee-torzsadat select:focus,
#new-employee-container.employee-torzsadat .custom-select:focus-within {
  border-color: #5bb65d !important;
  box-shadow: 0 0 0 3px rgba(178, 236, 93, 0.35), 0 10px 24px rgba(37, 39, 52, 0.09) !important;
  outline: none;
}

#new-employee-container.employee-torzsadat .row {
  margin-left: -8px;
  margin-right: -8px;
}

#new-employee-container.employee-torzsadat .row > [class*="col-"] {
  padding-left: 8px;
  padding-right: 8px;
}

.employee-action-column {
  align-items: flex-start;
  display: flex;
  gap: 4px;
  padding-bottom: 0;
  padding-top: 26px;
}

.employee-action-column .btn {
  height: 42px;
  min-height: 42px;
}

/* Label nélküli sorokban az ikonok a szomszédos mezőoszlop
   p-2 (8px) felső paddingjéhez igazodnak, így az input és a
   gombok felső éle egy vonalba kerül. */
.employee-action-column-no-label {
  padding-top: 4px;
}

#new-employee-container.employee-torzsadat .btn-light {
  align-items: center;
  background: #ffffff !important;
  border: 1px solid #AEBFC7 !important;
  border-radius: 999px !important;
  box-shadow: 0 8px 18px rgba(37, 39, 52, 0.08);
  display: inline-flex;
  justify-content: center;
  min-height: 38px;
}

#new-employee-container.employee-torzsadat .card {
  background: rgba(255, 255, 255, 0.76);
  border: 1px solid rgba(174, 191, 199, 0.7);
  border-radius: 24px;
  box-shadow: none;
  padding: 6px;
}

#new-employee-container.employee-torzsadat .text-danger {
  color: #9f1d1d !important;
  font-size: 12px;
}

.employee-floating-save-bar {
  align-items: center;
  backdrop-filter: blur(14px);
  background: rgba(255, 255, 255, 0.72);
  border: 1px solid rgba(174, 191, 199, 0.85);
  border-radius: 999px;
  bottom: 24px;
  box-shadow: 0 18px 44px rgba(37, 39, 52, 0.16);
  display: flex;
  justify-content: flex-end;
  left: 380px;
  padding: 6px 6px;
  position: fixed;
  width: calc(100% - 460px);
  z-index: 1050;
}

@media (min-width: 769px) {
  .employee-section-body.collapse:not(.show) {
    display: block !important;
    height: auto !important;
    visibility: visible !important;
  }
}

@media (max-width: 768px) {
  #new-employee-container.employee-torzsadat {
    padding-top: 16px !important;
  }

  .employee-layout,
  .employee-fields-grid {
    grid-template-columns: 1fr;
  }

  .employee-right-column {
    gap: 16px;
  }

  .employee-layout {
    gap: 16px;
  }

  .employee-section-card {
    border-radius: 28px;
    padding: 20px;
  }

  .employee-floating-save-bar {
    bottom: 92px;
    justify-content: flex-end;
    left: 0;
    padding: 6px 16px;
    border-radius: 999px;
    width: 100%;
  }

  #new-employee-container.employee-torzsadat .row > [class*="col-"] {
    flex: 0 0 100%;
    max-width: 100%;
  }
}

.ui.selection.dropdown {
  background-color: #edf5ec;
  border: none;
}

.custom-select input.search {
  background: none !important;
  box-shadow: none !important;
}

</style>
